import { TRPC_MAX_BATCH_SIZE, TRPC_MAX_URL_LENGTH } from '@repo/api-contracts';
import { httpBatchLink } from '@trpc/client';
import { env } from '../config/env';

/**
 * 요청마다 최신 access token 을 읽어 Authorization 헤더에 싣는다.
 * 같은 틱 호출은 한 요청으로 묶되 서버 배치 상한·GET URL 상한을 넘기 전에 나눈다 — 넘긴 배치는 서버가 통째로 400,
 * 긴 GET 은 nginx·CloudFront 가 414 로 거부한다(값과 근거는 api-contracts 의 trpc-transport.ts).
 */
export const createTrpcLinks = (getAccessToken: () => string | null) => [
  httpBatchLink({
    url: env.VITE_TRPC_URL,
    maxItems: TRPC_MAX_BATCH_SIZE,
    maxURLLength: TRPC_MAX_URL_LENGTH,
    headers: () => {
      const token = getAccessToken();
      return token ? { authorization: `Bearer ${token}` } : {};
    },
  }),
];
